/***
 * Returns stringified position plus suffix ('st', 'nd', 'rd', 'th')
 * Will pad with blanks as needed.
 * Invoke as `You were the${mapPosition(rank)}best player`
 *
 * Implementation:
 * - responsible for any needed blanks before and after string!
 */
export const mapPosition = (position: number, skipFirstPosition = true) => {
  switch (position) {
    case 1:
      return skipFirstPosition ? ' ' : ` ${position}st `
    case 2:
      return ` ${position}nd `
    case 3:
      return ` ${position}rd `
    case 4:
    case 5:
    case 6:
    case 7:
    case 8:
    case 9:
      return ` ${position}th `
    default:
      return ` ${position}th `
  }
}
